import gql from 'graphql-tag'

export const ListenDeviceStatuses = gql`
	subscription ListenDevicesUpdates {
		listenDeviceStatuses {
			id
			sender
			payload
		}
	}
`
